import React from 'react';
import { Lightbulb } from 'lucide-react';

interface AdvisorTipProps {
	/** Contenido del consejo. Usa <strong> para resaltar la idea clave. */
	children: React.ReactNode;
}

/**
 * Consejo de asesor financiero, idéntico al de las cajas del onboarding
 * (fondo crema + bombilla ámbar + texto ámbar). Pensado para sembrar
 * recomendaciones a lo largo de la vista.
 */
const AdvisorTip: React.FC<AdvisorTipProps> = ({ children }) => (
	<div className="flex gap-2 rounded-lg border border-amber-200/60 bg-amber-50 p-3">
		<Lightbulb className="mt-0.5 h-3.5 w-3.5 shrink-0 fill-amber-300 text-amber-600" />
		<p className="text-xs leading-relaxed text-amber-900">{children}</p>
	</div>
);

export default AdvisorTip;
